import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import {
	DisruptionAlert,
	NotificationRollset,
	RollshopNotification,
	RollshopNotificationData,
	StandTypeMismatchAlert,
} from "../models/RollshopNotification";

export const getRollshopNotifications = async (
	params: {
		shiftId?: number | null;
		start?: Date | null;
		end?: Date | null;
		statusCode?: string | null;
		actionTypeCode?: string | null;
		sourceCode?: string | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "ShiftId", value: params.shiftId || null },
		{ name: "Start", value: params.start ? params.start.toISOString() : null },
		{ name: "End", value: params.end ? params.end.toISOString() : null },
		{ name: "StatusCode", value: params.statusCode || null },
		{ name: "ActionTypeCode", value: params.actionTypeCode || null },
		{ name: "SourceCode", value: params.sourceCode || null },
	];

	const resp = await apiService.callV2(
		"[M2].[GetRollshopNotifications]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const notifications = get(
			resp,
			"data.tables[0].rows",
			[],
		) as RollshopNotification[];

		const rollsets = get(
			resp,
			"data.tables[1].rows",
			[],
		) as NotificationRollset[];

		const alerts = get(resp, "data.tables[2].rows", []) as DisruptionAlert[];

		const standTypeMismatches = get(
			resp,
			"data.tables[3].rows",
			[],
		) as StandTypeMismatchAlert[];

		return {
			notifications,
			rollsets,
			alerts,
			standTypeMismatches,
		} as RollshopNotificationData;
	} else {
		throw new Error(resp.message || "Error fetching notifications");
	}
};

export const acknowledgeNotification = async ({
	notificationIds,
	comments,
	markAsAcknowledge = true,
}: {
	notificationIds: string;
	comments?: string | null;
	markAsAcknowledge: boolean;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "NotificationIds", value: notificationIds },
		{ name: "Comments", value: comments || null },
		{ name: "MarkAsAcknowledge", value: markAsAcknowledge },
	];

	const resp = await apiService.callV2(
		"[M2].[AcknowledgeNotification]",
		parameters,
	);

	if (resp.ok) {
		return { ok: true, message: "Notification acknowledged successfully" };
	} else {
		throw new Error(resp.message || "Error acknowledging notification");
	}
};
